class Counter {
  constructor() {
    this.element = document.createElement("canvas");
    this.ctx = this.element.getContext("2d");

    this.element.width = 100;
    this.element.height = 100;
    this.timer = false;
    this.counter = 0;

    this.ctx.font = "40px Georgia, serif";
    this.ctx.textAlign = "center";
    this.ctx.textBaseline = "middle";
    this.step = this.step.bind(this);
  }

  start() {
    this.timer = setInterval(this.step, 100);
  }

  stop() {
    clearInterval(this.timer);
  }

  step() {
    this.counter = this.counter < 99 ? this.counter + 1 : 0;
    this.ctx.fillStyle = "black";
    this.ctx.fillRect(0, 0, 100, 100);
    this.ctx.fillStyle = "white";
    this.ctx.fillText(this.counter, 50, 50);
  }
}

export { Counter };
